<script setup>
const props = defineProps({
	color: String,
})
</script>

<template >
	<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.89149 3.18198L19.7671 21.0576C20.354 21.6445 21.3016 21.6445 21.8885 21.0576C22.4754 20.4707 22.4754 19.5232 21.8885 18.9363L4.01281 1.06066C3.42591 0.473762 2.47839 0.473762 1.89149 1.06066C1.30459 1.64756 1.30459 2.59508 1.89149 3.18198Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
		<path d="M19.7674 1.06075L1.89171 18.9364C1.30482 19.5233 1.30482 20.4708 1.89171 21.0577C2.47861 21.6446 3.42614 21.6446 4.01304 21.0577L21.8887 3.18207C22.4756 2.59517 22.4756 1.64765 21.8887 1.06075C21.3018 0.473853 20.3543 0.473853 19.7674 1.06075Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
	</svg>
</template>